export enum StatusEnum {
  INITIAL_CONTACT = 'INITIAL_CONTACT',
  PROPOSAL = 'PROPOSAL',
  CONTRACT = 'CONTRACT',
  SOLD = 'SOLD',
  CLOSED = 'CLOSED',
  DISTRACT = 'DISTRACT',
  GIVE_UP = 'GIVE_UP',
}
